<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';
import { PRICES } from '@presentation/Types/Settings';

import CarbucksProtectFeatures from './Components/CarbucksProtectFeatures.vue';
import CarbucksProtectNotableFeatures from './Components/CarbucksProtectNotableFeatures.vue';

const presentation = usePresentation();
presentation.registerTrigger();

</script>

<template>

    <Page>

        <div class="grid grid-cols-12 justify-center items-center gap-16 overflow-hidden w-full h-full">

            <div class="col-span-5 2xl:col-span-6 scale-[75%] xl:scale-[80%] 2xl:scale-100 left-2">
                <table class="
                    uppercase text-xs md:text-sm 2xl:text-base 3xl:text-lg text-center w-full 
                    border-separate rounded-lg ring-4 ring-white shadow-xl">
            
                    <tbody>

                        <tr class="font-semibold">
                            <td class="bg-indigo-600 rounded-tl-lg p-1 md:p-4">Category<br/>1</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Category<br/>2</td>
                            <td class="bg-indigo-600 p-1 md:p-4 border-gray-950">Category<br/>3</td>
                            <td class="bg-indigo-600 rounded-tr-lg p-1 md:p-4">Category<br/>4</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td class="bg-white text-black p-1 md:p-3 lg:px-8 2xl:px-10 text-xs 3xl:text-sm align-top">
                                <div class="font-semibold mb-2">
                                    Everyday cars
                                </div>
                                <div>
                                    Toyota, 
                                    Kia, 
                                    Mitsubishi,
                                    Mazda,
                                    etc.
                                </div>
                            </td>

                            <td class="bg-white text-black p-1 md:p-3 border-gray-950 text-xs 3xl:text-sm align-top">
                                <div class="font-semibold mb-2">
                                    Chinese Brands
                                </div>
                                <div>
                                    BYD,
                                    MG,
                                    Haval,
                                    GWM, 
                                    etc.
                                </div>
                            </td>

                            <td class="bg-white text-black p-1 md:p-3 border-gray-950 text-xs 3xl:text-sm align-top">
                                <div class="font-semibold mb-2">
                                    Premium &amp; Commercial 
                                </div>
                                <div>
                                    VW,
                                    Cupra,
                                    Utes,
                                    Light Commercial Vehicles,
                                    etc.
                                </div>
                            </td>

                            <td class="bg-white text-black p-1 md:p-3 text-xs 3xl:text-sm align-top">
                                <div class="font-semibold mb-2">
                                    Luxury Brands
                                </div>
                                <div>
                                    Mercedes,
                                    BMW,
                                    Audi,
                                    etc.
                                </div>
                            </td>
                        </tr>

                        <tr class="border-gray-950">
                            <td colspan="4" class="bg-gray-200 text-black p-1 md:p-3 ">Dealer Wholesale Cost</td>
                        </tr>

                        <tr class="border-gray-950 font-bold text-base 2xl:text-lg">
                            <td class="bg-gray-200 text-secondary-500 p-1 md:p-3">£325</td>
                            <td class="bg-gray-200 text-secondary-500 p-1 md:p-3 border-gray-950">£385</td>
                            <td class="bg-gray-200 text-secondary-500 p-1 md:p-3  border-gray-950">£455</td>
                            <td class="bg-gray-200 text-secondary-500 p-1 md:p-3">£605</td>
                        </tr>

                        <tr class="border-gray-950">
                            <td colspan="4" class="bg-white p-1 md:p-3 text-black">Recommended Retail Price</td>
                        </tr>

                        <tr class="border-gray-950 font-bold text-emerald-700 text-base 2xl:text-lg">
                            <td class="bg-secondary-300 rounded-bl-lg p-1 md:p-3">£640</td>
                            <td class="bg-secondary-300 p-1 md:p-3 border-gray-950">£700</td>
                            <td class="bg-secondary-300 p-1 md:p-3 border-gray-950">£770</td>
                            <td class="bg-secondary-300 rounded-br-lg p-1 md:p-3">£920</td>
                        </tr>

                    </tbody>

                </table>

                <div class="mt-3 text-xs 2xl:text-base text-white text-center">
                    <span class="font-semibold text-cyan-400">&gt; £315 margin</span>
                    on each contract (exc. VAT)
                </div>

                <div class="w-full h-8 absolute top-full translate-y-6"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />

            </div>

            <div class="col-span-7 2xl:col-span-6 left-10 w-full h-full scale-[80%] lg:scale-[90%] 2xl:scale-100">
                <div class="absolute w-full h-full left-0 top-0
                            transition duration-300
                            flex items-center rounded-2xl shadow-xl"
                    :class="presentation.currentTrigger == 0 ? 'opacity-0' : 'opacity-100'">
                    <CarbucksProtectFeatures
                        :show-conditions="true" 
                    />
                </div>
                <div class="absolute w-full h-full left-0 top-0
                            transition duration-300
                            flex flex-col justify-center items-start rounded-2xl shadow-xl"
                    :class="presentation.currentTrigger == 0 ? '-translate-x-4 opacity-100' : 'translate-x-full opacity-0'">
                    <CarbucksProtectNotableFeatures />
                </div>
            </div>

        </div>


    </Page>

</template>